const EventEmitter = require('eventemitter3');

export const ee = new EventEmitter();
